import React from "react";
import { ClientHeader } from "../HeaderFooter/ClientHeader";
import { ClientFooter } from "../HeaderFooter/ClientFooter";
interface Props {
  baseUrl?: string;
  cdnBasePath: string;
  year: string;
  errorMessage: string;
  errorLinkMessage: string;
}
export class ErrorBodyComponent extends React.Component<Props> {
  constructor (props: Props) {
    super(props);
  }
  componentDidMount() {
    window['pushDigitalData']({
      "event": "_pageLoaded",
      "page": {
        "environment": process.env.NODE_ENV
      }
    });
  }
  render() {
    const { baseUrl, cdnBasePath, year, errorMessage, errorLinkMessage } = this.props; 
    return (
      <div>
        <ClientHeader baseUrl={baseUrl} cdnBasePath={cdnBasePath} />
        <div className="error-body">
          <div className="col-xs-12 col-sm-8 text-wrapper">
            <h3 className="text-white">{errorMessage}</h3>
            <h4 className="text-white">
              <a href="/">{errorLinkMessage}</a>
            </h4>
          </div>
        </div>
        <ClientFooter baseUrl={baseUrl} year={year} />
      </div>
    );
  } 
};
